/*
 * A tooltip (Radix `Tooltip`). It only ever repeats or expands a control's own accessible name —
 * never carries information available nowhere else, because a tooltip is unreachable by touch and
 * by keyboard-only pointing. `TooltipProvider` is mounted once by the shell so the whole
 * application shares one open-delay.
 */

import * as RadixTooltip from "@radix-ui/react-tooltip"
import type { ReactNode } from "react"
import { emojiText } from "./emojiText.tsx"
import "./ui.css"

export const TooltipProvider = RadixTooltip.Provider

interface TooltipProps {
	/** Already translated. */
	label: string
	children: ReactNode
}

export function Tooltip({ label, children }: TooltipProps) {
	return (
		<RadixTooltip.Root>
			<RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
			<RadixTooltip.Portal>
				<RadixTooltip.Content className="tb-elevated tb-tooltip" sideOffset={6}>
					{emojiText(label)}
				</RadixTooltip.Content>
			</RadixTooltip.Portal>
		</RadixTooltip.Root>
	)
}
